import React from "react";
import Topbar from "./components/Topbar.jss";
import Footer from "./components/Footer.jss";

import "./style/main.scss";
import styles from "./style/layout_components/Layout.module.scss";

// Renders a route-not-found message when no route is available from Sitecore
// The JSS equivalent of a 404 Not Found page.

// This is invoked from RouteHandler when Sitecore returns no valid route data.
// The NotFound component receives the Layout Service Context data, but no route data.
// This can be used to power parts of your site, such as navigation, from LS context additions
// without losing the ability to render them on your 404 pages :)

const NotFound = ({ context = { site: { name: "" }, language: "" } }) => (
  <React.Fragment>
    <div className="site portaalderden">
      <Topbar />
      {/* root placeholder for the app, which we add components to using route data */}
      <div className={styles.wrap}>
        <main>
          <div className="page-not-found">
            <h1>Pagina niet gevonden</h1>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  </React.Fragment>
);

export default NotFound;
